import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserPortfolioSkillsEditModalComponent } from './user-portfolio-skills-edit-modal.component';

@NgModule({
  imports: [CommonModule, PipesModule, TrackingModule, UiModule],
  declarations: [UserPortfolioSkillsEditModalComponent],
})
export class UserPortfolioSkillsEditModalModule {}
